import { SatelliteApi } from "./api"
import { ImageryDay } from "./day"
import { SatelliteMap } from "./map"
import { ImageryProviderId } from "./providers"
import { Imagery, SatImageType } from "./types"

export class SatelliteContext {

    constructor(
        public readonly id: "layers" | "boundaries",
        public readonly api: SatelliteApi,
        public readonly map: SatelliteMap,
        public readonly days: ImageryDay[],
        public readonly selectedDay: ImageryDay,
        public readonly imagery: Imagery[],
        public readonly providerId: ImageryProviderId,
        public readonly imageType: SatImageType,
        public readonly close: (result: any) => void
    ) {


    }

    get date() {
        return this.selectedDay?.date
    }

}
